// @flow
import * as React from 'react'
import { Container } from './elements'

// Types
type Props = {
  children?: any,
  color?: 'blue' | 'red' | 'white' | 'green' | 'yellow',
}

/**
 * Component for showing any alert conent - in a box with border.
 * Could have some different predefined colors.
 * @return {Element}
 */
const Alert = ({ children, color = 'blue' }: Props) => (
  <Container $color={color}>{children}</Container>
)

export default Alert
